// 核对状态.tsx
import type { IFilterParams, IFilterComp } from "ag-grid-community";

// 获取翻译函数 - 使用全局翻译函数，避免在类组件中使用 Hook
const getTranslation = () => {
  // 使用全局 window.__t 函数，由 I18nProvider 设置
  return (window as any).__t || ((key: string) => key);
};

export class CustomCheckStateFilterComponent implements IFilterComp {
  private eGui: HTMLElement | null = null;
  private selectedCheckState: string | null = null;
  private filterParams: IFilterParams | null = null;
  private checkStateOptions: { value: string; label: string }[] = [];
  private isInitialized: boolean = false;
  private t: any;

  init(params: IFilterParams): void {
    this.filterParams = params;
    // 初始化翻译函数
    this.t = getTranslation();
    // 设置选项
    this.checkStateOptions = [
      { value: "PENDING", label: this.t("admin.pendingCheck") },
      { value: "CHECKED", label: this.t("admin.checked") },
    ];
    this.setupGui();
    this.isInitialized = true;
  }

  setupGui(): void {
    this.eGui = document.createElement("div");
    this.eGui.innerHTML = `
            <div style="padding: 8px; min-width: 100px; max-height: 300px; overflow-y: auto;">
                <div style="margin-bottom: 8px;">
                    <label style="display: flex; align-items: center; cursor: pointer;">
                        <input type="radio" name="checkstate-filter" value="" style="margin-right: 8px;" checked />
                        <span>${this.t("common.all")}</span>
                    </label>
                </div>
                <div style="border-top: 1px solid #e0e0e0; padding-top: 8px;" id="checkstate-list">
                    ${this.checkStateOptions
                      .map(
                        (option) => `
                        <div style="margin-bottom: 6px;">
                            <label style="display: flex; align-items: center; cursor: pointer;">
                                <input type="radio" name="checkstate-filter" value="${option.value}" style="margin-right: 8px;" />
                                <span>${option.label}</span>
                            </label>
                        </div>
                    `
                      )
                      .join("")}
                </div>
            </div>
        `;

    // 绑定事件
    const radios = this.eGui.querySelectorAll('input[type="radio"][name="checkstate-filter"]');
    radios.forEach((radio) => {
      radio.addEventListener("change", (e) => {
        const target = e.target as HTMLInputElement;
        const value = target.value;
        this.handleCheckStateChange(value || null);
      });
    });

    // 设置默认选中状态
    this.selectedCheckState = "";
  }

  handleCheckStateChange(checkState: string | null): void {
    // 只有在初始化完成后才处理状态变化
    if (!this.isInitialized) {
      return;
    }

    this.selectedCheckState = checkState;
    this.filterParams?.filterChangedCallback();

    // 触发父组件刷新
    this.triggerParentRefresh();
  }

  triggerParentRefresh(): void {
    // 确保只传递有效的值
    let valueToSend: string | undefined = undefined;

    if (this.selectedCheckState && this.selectedCheckState !== "") {
      valueToSend = this.selectedCheckState; // 传递实际选中的值
    }

    // 通过全局事件触发父组件刷新
    const event = new CustomEvent("filterChanged", {
      detail: {
        field: "checkState",
        value: valueToSend,
      },
    });
    window.dispatchEvent(event);
  }

  getGui(): HTMLElement {
    return this.eGui as HTMLElement;
  }

  isFilterActive(): boolean {
    return this.selectedCheckState !== null && this.selectedCheckState !== "";
  }

  doesFilterPass(params: any): boolean {
    if (!this.selectedCheckState || this.selectedCheckState === "") {
      return true;
    }
    return params.data.checkState === this.selectedCheckState;
  }

  getModel(): any {
    return this.selectedCheckState && this.selectedCheckState !== "" ? this.selectedCheckState : null;
  }

  setModel(model: any): void {
    if (model && typeof model === "string") {
      this.selectedCheckState = model;
    } else {
      this.selectedCheckState = ""; // 设置为空字符串表示"全部"
    }

    // 更新UI
    const radios = this.eGui?.querySelectorAll('input[type="radio"][name="checkstate-filter"]') || [];
    radios.forEach((radio) => {
      const input = radio as HTMLInputElement;
      input.checked = input.value === (this.selectedCheckState || "");
    });
  }

  destroy(): void {
    this.isInitialized = false;
  }
}

export default CustomCheckStateFilterComponent;
